<template>
    <v-container class="pagelogin">
    <div style="height: 18vh;"></div>
    <div class="loginForm">
  
      <v-card
      class="mx-auto pa-12 pb-8 login-card"
        elevation="8"
        max-height="615px"
        rounded="lg"
        width="400px"
      >
        <h2>Change my password</h2>
        <br>

        <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
        New password
      </div>

      <v-text-field
        :append-inner-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
        :type="passwordVisible ? 'text' : 'password'"
        density="compact"
        placeholder="Enter a new password"
        prepend-inner-icon="mdi-lock-outline"
        variant="outlined"
        @click:append-inner="passwordVisible = !passwordVisible"
        v-model="password"
      ></v-text-field>

  
        <v-btn
          block
          class="mb-8"
          color="blue"
          size="large"
          variant="tonal"
          @click="send_new_password"
        >
        CHANGE
        </v-btn>
      </v-card>
    </div>
  </v-container>
  </template>
  
  <script>

  import { useToast } from "vue-toastification";
  import { mapGetters } from 'vuex';
  
  export default {
    data: () => ({
      email: '',
      password: '',
      passwordVisible: false,
      captcha_payload: null
    }),
 
    computed: {
      ...mapGetters(['backend']),
    },
  
  
    methods: {
      handleCaptchaVerified(payload) { this.captcha_payload = payload },
      async send_new_password(){
        const toast = useToast();
        try{
        const urlParams = new URLSearchParams(window.location.search); 
        const token = urlParams.get('token');  
        const response = await this.$axios.post(`${this.backend}/api/user/reset-password`, {
            password: this.password,
            token: token
          });
          const res = response.data
          toast.success(res.message)
        }catch(err){
          toast.error((err.response.data.error).toString())
        }

      }
    }
  }
  </script>
  
  <style scoped>
  
  .pagelogin{
    display: flex;
      align-items: center; 
      justify-content: center;
      height: 100vh;  
  }
  
    .loginForm {
      display: flex;
      flex-direction: column;
      align-items: center; 
      justify-content: flex-start; 
      position: relative;
    }
  
    .login-card{
      background-color: rgba(34, 34, 34, 0.459);
    }
  
    
  
  </style>
  